module.exports = __webpack_public_path__ + "img/3.20fe9e48.svg";